/**
 * New Arrival Products — no front-end behaviour required.
 *
 * Unlike Popular Products, this block has no category tabs (the design has
 * none), so there is nothing to filter and no AJAX to wire up. The grid is
 * rendered server-side in render.php.
 */
